module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Light-3d5923f9.ttf";